import { createApi } from '@reduxjs/toolkit/query/react';
import { webApiResponseBaseQuery } from "./webApiResponseBaseQuery";
import type { Failure, WebApiResponseWithFailures } from "./WebApiResponse";
import { getConfig } from "@/config/config";
import type { LegalEntity } from '@/model/LegalEntity';

const prefixUrl = getConfig().prefixUrl ?? '';

export type AuditActionType = 'VALIDATE_CREATE'
  | 'VALIDATE_OPERATION' | 'VALIDATE_UPDATE' | 'VALIDATE_CANCEL'

export type RequestPayloadAudit = {
  entity: LegalEntity, // required
  userEmail: string | undefined,
  action: AuditActionType | undefined,
  startDate: string | undefined, // format : yyyy-mm-dd
  endDate: string | undefined,
  cashTransferId: string | undefined,
  isFailure: boolean | undefined,
  failureReason: string | undefined,
}

export type ResponsePayloadAudit = {
 audits: CashTransferAudit[]
}

export type CashTransferAudit = {
  id: string,
  entity: LegalEntity,
  name: string,
  action: AuditActionType,
  timestamp: string,
  reference: string,
  failureReason: string,
  duration: number, // in days
  failed: boolean,
}

export const auditApi = createApi({
  reducerPath: 'auditApi',
  keepUnusedDataFor: 3_600, // By defaut keep query data 1h even if unused
  baseQuery: webApiResponseBaseQuery,
  tagTypes: [],
  endpoints: (builder) => ({
    searchAudit: builder.query<
      // WebApiResponseWithFailures<ResponsePayloadAudit>,
      ResponsePayloadAudit,
      RequestPayloadAudit
    >({
      query: (request: RequestPayloadAudit) => ({
        method: 'POST',
        url: `${prefixUrl}/audits`,
        body: {
          ...request,
        },
        transformResponse: ({
          data: [details],
          failures = [] as Failure[],
        }: WebApiResponseWithFailures<ResponsePayloadAudit>) => ({
          data: details.audits,
          failures,
        }),
      }),
    }),
  })
})

export const {
  useSearchAuditQuery,
  useLazySearchAuditQuery,
} = auditApi